<template>
  <div>
    <v-form v-model="isFormValid" ref="form">
      <!-- Name -->
      <v-text-field
        label="Name"
        :value="entity.name"
        :rules="[ValidationRules.requiredString]"
        v-bind="globalFieldAttrs"
        @change="$emit('update', { name: $event })"
      />
      <!-- Section -->
      <AdminFieldRelated
        :item="entity"
        :id="entity.id"
        :Model="ItemModel"
        @update="$emit('update', $event)"
        :header="{
          value: 'section.name',
          foreignModel: SectionModel,
        }"
        label="Section"
      />
      <!-- Stock -->
      <AdminFieldStockStepper
        label="Stock"
        :value="entity.stock"
        @change="$emit('update', { stock: $event })"
        @update:delta="$emit('update', { stock_delta: $event })"
        v-bind="globalFieldAttrs"
      />
      <!-- Price -->
      <AdminFieldMoney
        label="Price"
        field-name="price"
        :value="entity.price"
        @price="$emit('update', { price: $event })"
        v-bind="globalFieldAttrs"
        :rules="[
          ValidationRules.requiredString,
          ValidationRules.unsignedNumberRule,
        ]"
      />
      <!-- Unit -->
      <v-text-field
        label="Unit"
        :value="entity.unit"
        v-bind="globalFieldAttrs"
        @change="$emit('update', { unit: $event })"
      />
      <!-- Description -->
      <v-textarea
        label="Description"
        :value="entity.description"
        auto-grow
        rows="3"
        @change="$emit('update', { description: $event })"
        v-bind="globalFieldAttrs"
      />

      <!-- Date -->
      <AdminFieldWrapper
        label="Item Date"
        v-if="getEnableItemDates || entity.date"
      >
        <AdminInputDatepicker
          label="Date"
          :disabled="!getEnableItemDates"
          :timestamp="entity.date"
          @input="$emit('update', { date: $event })"
          v-bind="globalFieldAttrs"
        />
      </AdminFieldWrapper>

      <!-- Sold Out -->
      <AdminFieldCheckbox
        :Model="ItemModel"
        :id="entity.id"
        label="Sold Out"
        size="x-large"
        field-name="sold_out"
        @click="$emit('update', { sold_out: !entity.sold_out })"
        v-bind="globalFieldAttrs"
      />
      <!-- Unlimited -->
      <AdminFieldCheckbox
        :Model="ItemModel"
        :id="entity.id"
        label="Unlimited"
        size="x-large"
        field-name="unlimited"
        @click="$emit('update', { unlimited: !entity.unlimited })"
        v-bind="globalFieldAttrs"
      />
      <!-- Hidden -->
      <AdminFieldCheckbox
        :Model="ItemModel"
        :id="entity.id"
        label="Hidden"
        size="x-large"
        field-name="hidden"
        @click="$emit('update', { hidden: !entity.hidden })"
        v-bind="globalFieldAttrs"
      />
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ItemModel from '@/models/ItemModel'
import SectionModel from '@/models/SectionModel'
import ValidationRules from '@/constants/ValidationRules'

import _get from 'lodash/get'

import AdminFieldWrapper from '@/components/AdminFieldWrapper'
import AdminFieldCheckbox from '@/components/AdminFieldCheckbox'
import AdminFieldRelated from '@/components/AdminFieldRelated'
import AdminFieldMoney from '@/components/AdminFieldMoney'
import AdminFieldStockStepper from '@/components/AdminFieldStockStepper'
import AdminInputDatepicker from '@/components/AdminInputDatepicker'
export default {
  name: 'AdminEditItemForm',
  components: {
    AdminFieldWrapper,
    AdminFieldCheckbox,
    AdminFieldRelated,
    AdminFieldMoney,
    AdminFieldStockStepper,
    AdminInputDatepicker,
  },
  props: {
    entity: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  data() {
    return {
      isFormValid: false,
      ValidationRules,
      ItemModel,
      SectionModel,
    }
  },
  mounted() {
    this.$refs.form.validate()
  },
  methods: {
    _get,
  },
  computed: {
    ...mapGetters('shop', ['getEnableItemDates']),

    globalFieldAttrs() {
      const defaults = { outlined: true, dense: true }
      return { ...defaults }
    },
  },
  watch: {
    isFormValid(validity) {
      this.$emit('form:valid', validity)
    },
  },
}
</script>
